<nav class="navbar navbar-expand-lg fixed-top">
    <a class="navbar-brand d-flex align-items-center py-1 ms-0" routerLink="/crm">
        <img src="/assets/logo-large.png" class="py-1" alt="Tiwi Land Council" />
    </a>

    @if (userService.watch | async; as _user) {
        @if (_user.loggedIn) {
            <div class="ms-auto" ngbDropdown display="dynamic" placement="bottom-end">
                <button class="btn profile-button" id="crmUserDropdownMenu" ngbDropdownToggle (click)="update()">
                    <ngxh6-usericon [user]="_user.account.user" [showTooltip]="false" class="me-0"></ngxh6-usericon>
                </button>
                <div ngbDropdownMenu aria-labelledby="crmUserDropdownMenu">
                    <h6 class="dropdown-header">{{ _user.account.user.name }}</h6>
                    <button class="dropdown-item" routerLink="/"><i class="fa fa-fw fa-globe me-2"></i> Public Site</button>
                    <!-- A staff account that also holds a Business Login lands in the CRM;
                         this lets them switch to their business area (e.g. TLC testing a BL). -->
                    @if (userService.isGranted(['ROLE_BUSINESS'])) {
                        <button class="dropdown-item" routerLink="/business"><i class="fa fa-fw fa-briefcase me-2"></i> Business area</button>
                    }
                    <button class="dropdown-item" routerLink="user-admin"><i class="fa fa-fw fa-user me-2"></i> My Profile</button>
                    <div class="dropdown-divider"></div>
                    <button class="dropdown-item warning" (click)="clearCaches()"><i class="fa fa-fw fa-trash me-2"></i> Clear Data Cache</button>
                    @if (!_user.account.impersonating) {
                        <button class="dropdown-item danger" (click)="userService.logOut()"><i class="fa fa-fw fa-sign-out me-2"></i> Logout</button>
                    }
                    @if (_user.account.impersonating) {
                        <button class="dropdown-item danger" (click)="userService.exitImpersonation()">
                            <i class="fa fa-fw fa-sign-out me-2"></i> Exit Impersonation
                        </button>
                    }
                    <div class="dropdown-divider"></div>
                    <h6 class="dropdown-header">Theme</h6>
                    @for (theme of themeService.themesKeys; track theme) {
                        <button class="dropdown-item theme-selector" (click)="themeService.setTheme(theme)">
                            <i
                                class="fa fa-fw me-2 fa-regular"
                                [class.fa-square-check]="theme === themeService.currentTheme"
                                [class.fa-square]="theme !== themeService.currentTheme"
                            ></i>
                            {{ themeService.themes[theme] }}
                        </button>
                    }
                    <div class="dropdown-divider"></div>
                    @if (userService.hasRole('ROLE_ADMIN')) {
                        <a class="dropdown-item" routerLink="debug"> <i class="fa fa-fw fa-bug me-2"></i> Debug</a>
                    }
                    <div class="dropdown-divider"></div>
                    <h6 class="dropdown-header">App Version {{ version }}</h6>
                    <h6 class="dropdown-header">Environment: {{ env }}</h6>
                </div>
            </div>
        }
    }
</nav>
